import type {LanguageSelectorTranslation} from './languageSelectorTranslationType';
import type {ChatiwiLocaleId} from '../localeLoaders';
import type {ComponentTranslationServerDefinition} from 'microsites/core/chatMicrosite/translations/componentTranslations';

const loadTranslation = (moduleExports: unknown): LanguageSelectorTranslation => (moduleExports as {translation: LanguageSelectorTranslation}).translation;

const syncLoaders: Record<ChatiwiLocaleId, () => LanguageSelectorTranslation> = {
  'ar-MA': () => loadTranslation(require(`./translations/ar-MA`)),
  'ar-SA': () => loadTranslation(require(`./translations/ar-SA`)),
  'de-DE': () => loadTranslation(require(`./translations/de-DE`)),
  'en-KE': () => loadTranslation(require(`./translations/en-KE`)),
  'en-NG': () => loadTranslation(require(`./translations/en-NG`)),
  'en-US': () => loadTranslation(require(`./translations/en-US`)),
  'es-ES': () => loadTranslation(require(`./translations/es-ES`)),
  'fa-IR': () => loadTranslation(require(`./translations/fa-IR`)),
  'fr-FR': () => loadTranslation(require(`./translations/fr-FR`)),
  'hi-IN': () => loadTranslation(require(`./translations/hi-IN`)),
  'it-IT': () => loadTranslation(require(`./translations/it-IT`)),
  'ja-JP': () => loadTranslation(require(`./translations/ja-JP`)),
  'ko-KR': () => loadTranslation(require(`./translations/ko-KR`)),
  'nl-NL': () => loadTranslation(require(`./translations/nl-NL`)),
  'pt-PT': () => loadTranslation(require(`./translations/pt-PT`)),
  'ru-RU': () => loadTranslation(require(`./translations/ru-RU`)),
  'sv-SE': () => loadTranslation(require(`./translations/sv-SE`)),
  'th-TH': () => loadTranslation(require(`./translations/th-TH`)),
  'tr-TR': () => loadTranslation(require(`./translations/tr-TR`)),
  'yue-Hant-HK': () => loadTranslation(require(`./translations/yue-Hant-HK`)),
  'zh-Hans-CN': () => loadTranslation(require(`./translations/zh-Hans-CN`)),
  'ar-AE': () => loadTranslation(require(`./translations/ar-AE`)),
  'ar-QA': () => loadTranslation(require(`./translations/ar-QA`)),
  'bn-BD': () => loadTranslation(require(`./translations/bn-BD`)),
  'da-DK': () => loadTranslation(require(`./translations/da-DK`)),
  'de-AT': () => loadTranslation(require(`./translations/de-AT`)),
  'de-CH': () => loadTranslation(require(`./translations/de-CH`)),
  'en-SG': () => loadTranslation(require(`./translations/en-SG`)),
  'fi-FI': () => loadTranslation(require(`./translations/fi-FI`)),
  'id-ID': () => loadTranslation(require(`./translations/id-ID`)),
  'is-IS': () => loadTranslation(require(`./translations/is-IS`)),
  'mr-IN': () => loadTranslation(require(`./translations/mr-IN`)),
  'no-NO': () => loadTranslation(require(`./translations/no-NO`)),
  'pa-PK': () => loadTranslation(require(`./translations/pa-PK`)),
  'pcm-NG': () => loadTranslation(require(`./translations/pcm-NG`)),
  'pl-PL': () => loadTranslation(require(`./translations/pl-PL`)),
  'pt-BR': () => loadTranslation(require(`./translations/pt-BR`)),
  'sw-KE': () => loadTranslation(require(`./translations/sw-KE`)),
  'te-IN': () => loadTranslation(require(`./translations/te-IN`)),
  'ur-PK': () => loadTranslation(require(`./translations/ur-PK`)),
  'vi-VN': () => loadTranslation(require(`./translations/vi-VN`)),
};

export const languageSelectorTranslationDefinition: ComponentTranslationServerDefinition<LanguageSelectorTranslation> = {
  cacheKey: `languageSelector`,
  syncLoaders,
};
